import { useEffect, useState } from 'react'
import { orario, syncPortaliApi, type SyncPortaleStato } from '../api/syncPortali'
import { Button } from './ui'

const NOMI: Record<string, string> = { ermes: 'Ermes', teamwork: 'Teamwork', coraly: 'Coraly' }

/**
 * "Sync tutti i portali": aggiorna tutta la produzione in un colpo, senza aspettare i giri ogni 10 minuti. Ermes e
 * Teamwork passano dal server (richiesta eseguita entro un minuto, con lo stesso lock del cron); Coraly si legge dal CRM.
 * Visibile solo a chi può chiederlo (staff Equal: il server risponde 403 agli altri e il pulsante non compare).
 */
export function SyncAllPortalsButton({ onDone, compact }: { onDone?: () => void; compact?: boolean }) {
  const [allowed, setAllowed] = useState(false)
  const [busy, setBusy] = useState(false)
  const [righe, setRighe] = useState<string[]>([])

  useEffect(() => {
    let alive = true
    syncPortaliApi.list().then(() => { if (alive) setAllowed(true) }).catch(() => { if (alive) setAllowed(false) })
    return () => { alive = false }
  }, [])

  const descrivi = (s: SyncPortaleStato) =>
    `${NOMI[s.gestore] ?? s.gestore}: ${s.inCorso ? (s.avviataIl && s.richiestaIl && s.avviataIl >= s.richiestaIl ? 'lettura del portale…' : 'in attesa del server…')
      : s.esito === 'in pausa' ? 'in pausa' : `aggiornato alle ${orario(s.eseguitaIl)}${s.esito && s.esito !== 'ok' ? ` (${s.esito})` : ''}`}`

  async function run() {
    setBusy(true)
    setRighe(['Sync richiesto…'])
    try {
      let stati = await syncPortaliApi.requestAll()
      const coraly = syncPortaliApi.coralyAll().then(r => `Coraly: ${r.cards} card aggiornate`).catch(e => `Coraly: ${e instanceof Error ? e.message : 'errore'}`)
      let coralyRiga = 'Coraly: lettura…'
      void coraly.then(r => { coralyRiga = r })
      const end = Date.now() + 15 * 60_000
      const aggiorna = () => setRighe([...stati.map(descrivi), coralyRiga])
      aggiorna()
      while (stati.some(s => s.inCorso) && Date.now() < end) {
        await new Promise(r => setTimeout(r, 5000))
        stati = await syncPortaliApi.list()
        aggiorna()
      }
      coralyRiga = await coraly
      aggiorna()
      onDone?.()
    } catch (err) {
      setRighe([err instanceof Error ? err.message : 'Sync non riuscito.'])
    } finally {
      setBusy(false)
    }
  }

  if (!allowed) return null
  return (
    <span style={{ display: 'inline-flex', alignItems: 'center', gap: 8, flexWrap: 'wrap' }}>
      <Button type="button" variant={compact ? 'text' : 'outlined'} size={compact ? 'sm' : undefined} icon="sync" onClick={() => { void run() }} disabled={busy}>
        {busy ? 'Sync in corso…' : 'Sync tutti i portali'}
      </Button>
      {righe.length > 0 && (
        <span className="md-typescale-body-small" title={righe.join('\n')}>
          {righe.join(' · ')}
        </span>
      )}
    </span>
  )
}
